(function (Backbone) {
	Backbone.SmartCollection = Backbone.Collection.extend({
		update: function (models, opts) {
			Backbone.Collection.prototype.update.apply(this, arguments);
			if (!opts || !opts.silent) {
				this.trigger('update', this, opts);
			}
		}
	});
}(Backbone));